import { PATHS } from "@/lib/router";
import EsgDashboardPage from "./pages/EsgDashboardPage";

export const esgDashboardRoutes = [
  {
    path: PATHS.ANALYTICS_DASHBOARD,
    element: <EsgDashboardPage />,
    handle: { permission: { resource: "esg_dashboard", action: "view" } },
  },
];
